import LoadingPage from 'apps/components/molecules/LoadingPage'
import React from 'react'
import loadable from 'apps/utils/loadable'

export default loadable(() => import('./index'), {
  fallback: <LoadingPage />,
})
